<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App',
    }
</script>

<style>
    body {
        background-color: #fafafa;
        max-width: 100vw;
    }

    .card {
        margin: 10px 0;
    }

    body {
        font-size: 15px;
    }
</style>
